import { MultiSearchStoresScreen } from '../features/multisearch'

export function MultiSearchStoresPage() {
  return <MultiSearchStoresScreen />
}
